import { useMemo } from 'react';

import type { APPLICANT_ATTRIBUTION_BOTH_TYPE } from 'cpool-constants';
import { ALPHA_2_ISO_3166, APPLICANT_ATTRIBUTION_BOTH, EMPLOYMENT_INDUSTRY } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

export type DropdownOption = {
    label: string;
    value: string;
};

/**
 * Options for the KN attribution SegmentedControls (Kontoinhaber, Kind zugeordnet zu, Eigentümer):
 * Gemeinsam | Kreditnehmer 1 | Kreditnehmer 2.
 */
export const useApplicantAttributionOptions = (): {
    label: string;
    value: APPLICANT_ATTRIBUTION_BOTH_TYPE;
}[] => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            { label: t('APPLICANT_ATTRIBUTION.BEIDE'), value: APPLICANT_ATTRIBUTION_BOTH.BEIDE },
            { label: t('APPLICANT_ATTRIBUTION.ANTRAGSTELLER_1'), value: APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_1 },
            { label: t('APPLICANT_ATTRIBUTION.ANTRAGSTELLER_2'), value: APPLICANT_ATTRIBUTION_BOTH.ANTRAGSTELLER_2 },
        ],
        [t],
    );
};

export const useBranchOptions = (): DropdownOption[] => {
    const { t } = useTranslation();

    return useMemo(
        () =>
            Object.values(EMPLOYMENT_INDUSTRY).map((value) => ({
                label: t(`INDUSTRY.${value}`),
                value,
            })),
        [t],
    );
};

export const useCountryOptions = (): DropdownOption[] => {
    const { t } = useTranslation();

    return useMemo(
        () =>
            Object.values(ALPHA_2_ISO_3166).map((value) => ({
                label: t(`countries.${value}`),
                value,
            })),
        [t],
    );
};
